import 'codemirror/mode/jsx/jsx';
import 'codemirror/addon/comment/comment';
export { default } from 'codemirror';
